'use strict';

angular.module('nfseApp')
    .controller('EnviarNotaEmailController', function ($scope, entity, NotaFiscal, ParseLinks, SweetAlert, $modalInstance) {
        $scope.notaFiscal = entity;

        $scope.ok = function () {
            NotaFiscal.enviarPorEmail($scope.notaFiscal, function(data){
                $modalInstance.close($scope.notaFiscal);
                SweetAlert.info("Enviado", "O email foi enviado aos destinatários", "info");
            }, function (err) {
                SweetAlert.info("Operação não realizada", "não foi possível enviar o email aos destinatários", "error");

            });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });
